export const REDIRECT_CZ = {
  '/katalog-vyrobku': '/recepty-domu',
  '/recepty/spenatove-jednohubky-s-zampiony': '/recepty/r/spenatove-jednohubky-se-zampiony/czgp003',
  '/katalog-vyrobku/sterilovana-zelenina/creatif-zeleninove-smesi/creatif-mexico': '/zelenina/p/creatif-mexico-zeleninova-smes-vakuovana-v-mirne-slanem-nalevu/03083680715447',
  '/recepty/cockovy-salat-s-mozzarelou': '/recepty/r/cockovy-salat-s-mozzarelou/czgp165'
}
